import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN, LARGE_MARGIN, MIDDLE_MARGIN } from '../../theme';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        display: 'flex',
        color: colorsPalette.white,
        background: theme.palette.secondary.dark,
        position: 'relative',
        overflow: 'hidden',
        [theme.breakpoints.up('sm')]: {
          paddingTop: LARGE_MARGIN,
          paddingBottom: LARGE_MARGIN,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
      },
      container: {
        position: 'relative',
        display: 'flex',
      },
      content: {
        borderRadius: '5px',
        padding: `${MIDDLE_MARGIN}px 24px`,
        background: theme.palette.secondary.dark,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up('sm')]: {
          width: 480,
          padding: 0,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
        [theme.breakpoints.down('md')]: {
          margin: 'auto',
        },
        [theme.breakpoints.up('md')]: {
          alignItems: 'flex-start',

          minWidth: 480,
        },
      },
      wideImg: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
          display: 'block',
          position: 'relative',
          marginLeft: LARGE_MARGIN,
          left: 0,
          top: 0,
        },
        '& img': {
          width: 'initial',
        },
      },
      button: {
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      heading: {
        marginBottom: SMALL_MARGIN,
        width: '100%',
        [theme.breakpoints.down('md')]: {
          textAlign: 'center',
        },
      },
      items: {
        marginTop: 22,
        marginBottom: 28,
        width: '100%',
        [theme.breakpoints.up('md')]: {
          marginTop: MIDDLE_MARGIN,
          marginBottom: MIDDLE_MARGIN,
        },
      },
      item: {
        display: 'flex',
        marginBottom: 32,
      },
      imageWrap: {
        width: '48px',
        flexShrink: 0,
        [theme.breakpoints.up('md')]: {
          width: 65,
        },
        '& img': {
          width: '100%',
        },
      },
      textWrapper: {
        paddingLeft: SMALL_MARGIN,
      },
      itemTitle: {
        fontSize: 24,
        lineHeight: 1,
        marginBottom: 10,
      },
      itemText: {
        fontSize: 16,
        lineHeight: 1.6,
        color: colorsPalette.gray,
      },
    }),
  );

export default useStyles;
